import React, { useState, useEffect } from 'react';

import FURGAPI from '../../../services/api.furg';
import Preview from './Preview/index';
import { Alert } from '../../Alert';

import { uniqueId } from 'lodash';

import { FaUpload } from 'react-icons/fa';

import { decodeHexHtmlCharCodes } from '../../../services/utils';

const FileList = ({ id_documento, tipos_arquivos_aceitos = null, onPodeConfirmarEnvio = valor => {} }) => {
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const inputAcceptsFiles = tipos_arquivos_aceitos ?? '.jpg,.png,.jfif,.jpeg,.pdf';

    const updateFile = (key, data) => {
        setUploadedFiles(state =>
            state.map(file => {
                return key === file.key ? { ...file, ...data } : file;
            })
        );
    };

    const sendFile = file => {
        const data = new FormData();
        data.append('file', file.file);

        FURGAPI.upload(data)
            .then(resposta => {
                updateFile(file.key, { uploaded: true, key: resposta.key });
            })
            .catch(err => {
                updateFile(file.key, { uploaded: false, error: decodeHexHtmlCharCodes(err) });
            });
    };

    const handleChangeFile = e => {
        onPodeConfirmarEnvio(false);

        const files = e?.target?.files;
        if (null !== files) {
            const uploadFiles = [...files].map(file => ({
                file,
                key: uniqueId(),
                preview: URL.createObjectURL(file),
                uploaded: false,
                error: false,
                url: null,
            }));

            setUploadedFiles(state => [...state, ...uploadFiles]);

            uploadFiles.forEach(file => {
                sendFile(file);
            });
        }
        e.target.value = '';
    };

    const handleRemove = key => {
        setUploadedFiles(state => {
            return state.filter(file => {
                return key !== file.key;
            });
        });
    };

    const obtemArquivosEnviadosComErro = () => uploadedFiles.filter(file => !file.uploaded && file.error !== false);

    const obtemQtdArquivosEnviadosComSucesso = () => uploadedFiles.filter(file => file.uploaded).length;

    useEffect(() => {
        const totalArquivosEnviadosComSucesso = uploadedFiles.filter(file => file.uploaded).length;
        const totalArquivosEnviadosComErro = uploadedFiles.filter(file => !file.uploaded && file.error !== false).length;
        const validouUpload = 0 === uploadedFiles.length - totalArquivosEnviadosComSucesso - totalArquivosEnviadosComErro;

        validouUpload && onPodeConfirmarEnvio && onPodeConfirmarEnvio(true);
    }, [uploadedFiles, onPodeConfirmarEnvio]);

    return (
        <>
            <div style={{ fontSize: '.9em' }} className="mt-3 mb-2 text-left">
                {obtemQtdArquivosEnviadosComSucesso()} documento(s) enviado(s)
            </div>

            {obtemArquivosEnviadosComErro().length > 0 && (
                <Alert variant="danger" icon={false}>
                    <ul className="text-left mb-2">
                        {obtemArquivosEnviadosComErro().map(arquivo => (
                            <li key={arquivo.key}>
                                <strong>
                                    - Erro ({arquivo.file.name}): {arquivo.error}
                                </strong>
                            </li>
                        ))}
                    </ul>
                </Alert>
            )}

            <div className="d-flex" style={{ flexWrap: 'wrap' }}>
                {uploadedFiles.map((arquivo, index) => (
                    <Preview key={arquivo.key} index={index} onRemove={() => handleRemove(arquivo.key)} arquivo={arquivo} />
                ))}
            </div>

            <div className="d-flex flex-column mt-2">
                <div className="form-group">
                    <label className="btn btn-primary" htmlFor={`enviar_mais_documentos_${id_documento}`}>
                        <input id={`enviar_mais_documentos_${id_documento}`} type="file" accept={inputAcceptsFiles} multiple className="d-none" onChange={handleChangeFile} />
                        <FaUpload size={14} /> Enviar mais documentos
                    </label>
                </div>
            </div>
        </>
    );
};
export default FileList;
